export default __webpack_public_path__ + "static/media/swmlogo2.d9a156db.png";